const geocodingKind = {
   yandex: {
      house: "отдельный дом",
      street: "улица",
      metro: "станция метро",
      district: "район города",
      locality: "населённый пункт: город / поселок / деревня / село и т. п.",
      area: "район области",
      province: "область",
      country: "страна",
      hydro: "река / озеро / ручей / водохранилище и т. п.",
      railway: "ж.д. станция	",
      route: "линия метро / шоссе / ж.д. линия",
      vegetation: "лес / парк / сад и т. п.",
      airport: "аэропорт",
      other: "прочее",
   },
    google: {
        street_address: "почтовый адрес",
        route: "шоссе",
        intersection: "перекресток",
        political: "район города",
        country: "населённый пункт: город / поселок / деревня / село и т. п.",
        administrative_area_level_1: "административная единица 1 порядка",
        administrative_area_level_2: "административная единица 2 порядка (округ)",
        administrative_area_level_3: "административная единица 3 порядка",
        administrative_area_level_4: "административная единица 4 порядка",
        administrative_area_level_5: "административная единица 5 порядка",
        colloquial_area: "общепринятое альтернативное название единицы",
        locality: "населённый пункт: город / поселок / деревня / село и т. п.",
        ward: "округ",
        sublocality: "административная единица 1 порядка ниже уровня населенного пункта",
        neighborhood: "район",
        premise: "дом",
        subpremise: "корпус",
        postal_code: "почтовый индекс",
        natural_feature: "природный объект",
        airport: "аэропорт",
        park: "парк",
        point_of_interest: "достопримечательность",
        floor: "этаж",
        establishmen: "место",
        parking: "парковка",
        post_box: "почтовый ящик",
        postal_town: "группа объектов",
        room: "комната",
        street_number: "номер дома",
        bus_station: "автобусная станция",
        train_station: "ж/д вокзал",
        transit_station: "остановка общественного транспорта"
    }
};

const geocodingPrecision = {
   yandex: {
      exact: "точное соответствие",
      number: "совпал номер дома, но не совпало строение или корпус",
      near: "найден дом с номером, близким к запрошенному",
      range: "ответ содержит приблизительные координаты запрашиваемого дома",
      street: "найдена только улица",
      other: "лица не найдена, но найден объект более высокого уровня"
   },
    google: {
        ROOFTOP: "точное соответствие",
        RANGE_INTERPOLATED: "интерполированное местоположение",
        GEOMETRIC_CENTER: "геометрический центр результата (например, улицы или района)",
        APPROXIMATE: "приблизительное местоположение"
    }
};

module.exports = {
   geocodingKind: geocodingKind,
   geocodingPrecision: geocodingPrecision
};